import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = {
  get: (url, config) => axios.get(`${API}${url}`, config),
  post: (url, data, config) => axios.post(`${API}${url}`, data, config),
  put: (url, data, config) => axios.put(`${API}${url}`, data, config),
  delete: (url, config) => axios.delete(`${API}${url}`, config),
};

export const getAdminHeaders = (password) => ({
  "x-admin-password": password,
});
